import firebase from 'firebase/app';
import 'firebase/auth';
import {
  LOGIN,
  LOGOUT,
  CHECK_AUTH,
  RESET_PASS
} from "./actions.type";
import { SET_AUTH, PURGE_AUTH, SET_ERROR } from "./mutations.type";

const state = {
  errors: null,
  user: {},
  isAuthenticated: false
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, loginInfo) {
      return new Promise((resolve, reject) => {
        firebase.auth().signInWithEmailAndPassword(loginInfo.email, loginInfo.password)
        .then((user) =>{
          context.commit(SET_AUTH, user);

          resolve(user);
        })
        .catch(function(error) {
          if(error.code == 'auth/user-not-found' || error.code == 'auth/wrong-password') {
            context.commit(SET_ERROR, 'Invalid login information');
          } else {
            context.commit(SET_ERROR, error.message);
          }

          // console.log(error.code)
          reject(error.message)
          // Handle Errors here.
          //var errorCode = error.code;
          //var errorMessage = error.message;
          // ...
        });
      })
  },
  [LOGOUT](context) {
    return new Promise((resolve, reject) => {
      firebase.auth().signOut()
      .then(function() {
        // Sign-out successful.
        context.commit(PURGE_AUTH);
        resolve()
      })
      .catch(function(error) {
        context.commit(SET_ERROR, error.message);
        reject(error)
        // An error happened
      });
    })
  },
  [RESET_PASS](context, loginInfo) {
      return new Promise((resolve, reject) => {
        firebase.auth().sendPasswordResetEmail(loginInfo.email)
        .then(function(){
          //context.commit(PURGE_AUTH);
          resolve()
        })
        .catch(function(error) {
          console.log(error); 
          if(error.code == 'auth/user-not-found')  {                       
            context.commit(SET_ERROR, 'Invalid login information');
          } else {            
            context.commit(SET_ERROR, error.message);                      
          }         
          reject(error.message);  
        });
      })
  },
  [CHECK_AUTH](context) {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged((user) =>{
        if (user) {
          context.commit(SET_AUTH, user);
          resolve(user);
        } else {
          context.commit(PURGE_AUTH);
          reject();
        }
      })
    })
  },
  // [UPDATE_USER](context, payload) {
  //
  // }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
